import { Star } from "lucide-react";
import { cn } from "@workspace/ui/lib/utils";

import type { ShelfBook } from "./book-parts";

/** When the book was finished, how long it is and how it was rated. `muted` colours the facts. */
export function BookFacts({ book, muted }: { book: ShelfBook; muted: string }) {
  const facts = [
    book.shelf === "reading" && "Reading now",
    book.finishedOn &&
      `Finished ${new Date(`${book.finishedOn}T00:00:00Z`).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
        timeZone: "UTC",
      })}`,
    book.pages && `${book.pages.toLocaleString("en-GB")} pages`,
  ].filter(Boolean);

  return (
    <>
      <p className={muted}>{facts.join(" · ")}</p>
      {book.rating && <Rating value={book.rating} />}
    </>
  );
}

function Rating({ value }: { value: number }) {
  return (
    <div className="flex gap-1" role="img" aria-label={`Rated ${value} out of 5`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          aria-hidden
          className={cn("size-4", n <= value ? "fill-amber-400 text-amber-400" : "text-current/20")}
        />
      ))}
    </div>
  );
}
